import LoginPage from '@/views/login/LoginPage'

export default function Page() {
  return <LoginPage />
}
